
import * as React from 'react';

const Dropdown = (props) => {
    const { ddlList, value, label, selectedValue } = props;
    
    const onChangeDdl = async (evt, data) => {
        $(`#${props.id}`).removeClass('open');
        props.onDdlCallback(data);
    }

    const selectedText = ((ddlList && selectedValue) &&
        (value ? (ddlList.find(f => f[`${value}`] === selectedValue)[`${label}`])
            : (ddlList.find(f => f === selectedValue)))
    )

    return (
        <>
            <div className="dropdown selectbox order-dropdown show" id={props.id}>
                <a className="bs5 form-control form-control-sm text-black dropdown-control w180 my-cart-address-select dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span> {selectedValue ? selectedText : props.defaultText}</span>
                </a>
                <ul className="dropdown-menu minw180" aria-labelledby="dropdownMenuLink">
                    <li value="">
                        <a className="dropdown-item text-black" onClick={async (e) => {
                            onChangeDdl(e, "");
                        }}><p>{props.defaultText}</p></a>
                    </li>
                    {(ddlList && ddlList.length > 0) &&
                        ddlList.map((v) => (
                            <li key={value ? v[`${value}`] : v}
                                value={value ? v[`${value}`] : v}
                                className={(selectedValue === (value ? v[`${value}`] : v)) ? 'active' : ""}
                                onClick={async (e) => {
                                    onChangeDdl(e, value ? v[`${value}`] : v);
                                }}
                            >
                                <a className="dropdown-item text-black"><p>{label ? v[`${label}`] : v}</p></a>
                            </li>
                        ))
                    }
                </ul>

            </div>
        </>
    );

};

export default React.memo(Dropdown);

